import React, { useEffect, useState, useRef } from 'react'
import styles from "./Myproject.module.css"
import { useParams } from 'react-router-dom';
import { delete_project_Api, get_all_project_Api, update_project_Api } from '../../dashboardapi';
import { useToast } from '@chakra-ui/react';
import Modal from "./Modal"
import templatestyle from "./TemplateModal.module.css"
import { useOutletContext } from 'react-router-dom';
const TrashedProjects = () => {
    const [projects, setProjects] = useState([]);
    const [activeTrashTab, setActiveTrashTab] = useState("project");
    const [search, setSearch] = useState("");
    const { project } = useParams();
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedEnv, setSelectedEnv] = useState(false);
    const RemovefromTrashref = useRef();
    const { ToogleSidebars } = useOutletContext();


    const toast = useToast();

    const fetchTrashedProjects = async () => {
        let response = await get_all_project_Api();
        if (response.data && response.data.trashed) {
            setProjects(response.data.trashed);
        } else {
            setProjects([])
        }
    };
    const filteredProjects = projects.filter((p) => {
        const text = search.toLowerCase().trim();
        return p.name.toLowerCase().trim().startsWith(text);
    });

    useEffect(() => {
        function closeRemoveModal(e) {
            if (showDeleteModal && RemovefromTrashref.current && !RemovefromTrashref.current.contains(e.target)) {
                setShowDeleteModal(false);
            }
        }
        document.addEventListener('mousedown', closeRemoveModal);
        return () => document.removeEventListener('mousedown', closeRemoveModal);
    }, [showDeleteModal])

    useEffect(() => {
        if (project === 'trashedprojects') {
            fetchTrashedProjects();
        }
    }, [])


    const handleDelete = async (id) => {
        let result = await delete_project_Api(id);
        if (result.data) {
            toast({
                title: "Project deleted Successfully",
                description: result.data.message,
                status: "success",
                duration: 2000,
                isClosable: "true"

            })
            setProjects((prev) => prev.filter((items) => items.uuid !== id));
        } else {
            let error = result.error.message || "error Occurred"
            toast({
                title: "Problem deleting project",
                description: error,
                status: "error",
                duration: 2000,
                isClosable: "true"

            })
        }
        setShowDeleteModal(false)
    }
    const templateIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-folder2" viewBox="0 0 16 16"><path d="M1 3.5A1.5 1.5 0 0 1 2.5 2h2.764c.958 0 1.76.56 2.311 1.184C7.985 3.648 8.48 4 9 4h4.5A1.5 1.5 0 0 1 15 5.5v7a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 1 12.5zM2.5 3a.5.5 0 0 0-.5.5V6h12v-.5a.5.5 0 0 0-.5-.5H9c-.964 0-1.71-.629-2.174-1.154C6.374 3.334 5.82 3 5.264 3zM14 7H2v5.5a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5z" /></svg>

    const undelete = async (id) => {
        let result = await update_project_Api(id);
        if (result.data) {
            toast({
                title: "Project restored successfully",
                description: result.data.message,
                status: "success",
                duration: 2000,
                isClosable: "true"
            })
            fetchTrashedProjects();
        } else {
            let error = result.error.message || "error Occurred"
            toast({
                title: "Failed to restore project",
                description: error,
                status: "error",
                duration: 2000,
                isClosable: "true"
            })
        }
    }

    return (
        <div className={styles.product_page_outer}>
            <div className={styles.indivprojectouter}>

                <div className={styles.project_heading}>
                    <div className={styles.dashboardSidebarIcon}>
                        <svg onClick={() => { if (window.innerWidth < 769) { ToogleSidebars(true) } }} width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 3H4C3.44772 3 3 3.44772 3 4V11C3 11.5523 3.44772 12 4 12H9C9.55228 12 10 11.5523 10 11V4C10 3.44772 9.55228 3 9 3Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M20 3H15C14.4477 3 14 3.44772 14 4V7C14 7.55228 14.4477 8 15 8H20C20.5523 8 21 7.55228 21 7V4C21 3.44772 20.5523 3 20 3Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M20 12H15C14.4477 12 14 12.4477 14 13V20C14 20.5523 14.4477 21 15 21H20C20.5523 21 21 20.5523 21 20V13C21 12.4477 20.5523 12 20 12Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M9 16H4C3.44772 16 3 16.4477 3 17V20C3 20.5523 3.44772 21 4 21H9C9.55228 21 10 20.5523 10 20V17C10 16.4477 9.55228 16 9 16Z" stroke="currentColo" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        <p>Trashed Projects & Templates</p>
                    </div>
                </div>
                <div className={styles.Dashboardmaincontents}>
                    <div className={styles.dashboardsearchoption}>

                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px" }}>
                            <button className={activeTrashTab === "project" ? styles.activeTrashbar : styles.inactiveTrashbar} onClick={() => { setActiveTrashTab("project") }}>Projects</button>
                            <button className={activeTrashTab === "template" ? styles.activeTrashbar : styles.inactiveTrashbar} onClick={() => { setActiveTrashTab("template") }}>Templates</button>

                        </div>
                        <div className={styles.dashboardsearchfield}>
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.75 5.41667C0.75 6.0295 0.870707 6.63634 1.10523 7.20252C1.33975 7.76871 1.68349 8.28316 2.11683 8.7165C2.55017 9.14984 3.06462 9.49358 3.63081 9.7281C4.197 9.96263 4.80383 10.0833 5.41667 10.0833C6.0295 10.0833 6.63634 9.96263 7.20252 9.7281C7.76871 9.49358 8.28316 9.14984 8.7165 8.7165C9.14984 8.28316 9.49358 7.76871 9.7281 7.20252C9.96263 6.63634 10.0833 6.0295 10.0833 5.41667C10.0833 4.80383 9.96263 4.197 9.7281 3.63081C9.49358 3.06462 9.14984 2.55017 8.7165 2.11683C8.28316 1.68349 7.76871 1.33975 7.20252 1.10523C6.63634 0.870707 6.0295 0.75 5.41667 0.75C4.80383 0.75 4.197 0.870707 3.63081 1.10523C3.06462 1.33975 2.55017 1.68349 2.11683 2.11683C1.68349 2.55017 1.33975 3.06462 1.10523 3.63081C0.870707 4.197 0.75 4.80383 0.75 5.41667Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M12.75 12.75L8.75 8.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <input type='text' placeholder='Search Your Project' value={search}
                                onChange={(e) => setSearch(e.target.value)} /></div>
                    </div>



                    {
                        activeTrashTab === "project" && (
                            <>
                                <div className={styles.indivprojectlist}>
                                    {filteredProjects.length > 0 ? filteredProjects.map((item, i) => (
                                        <div key={i} className={styles.indivproject} >
                                            <div className={styles.projectContainer}>
                                                <div className={styles.nameContainer}>
                                                    <div className={styles.dashboardfileicons}>{templateIcon()}</div>
                                                    <div className={styles.nameanddatecontainer}>
                                                        <h2>{item.name}</h2>

                                                        <div className={styles.dateandproject}>

                                                            {/* <p style={{ textWrap: "nowrap", overflow: "hidden" }} title={item.env_name} >
                                                        {item.env_name}</p> */}
                                                            {
                                                                item.env_name && (
                                                                    <>
                                                                        <div className={styles.templateContainer}>
                                                                            <img src={process.env.PUBLIC_URL + "/NewPages/Dashboard/DashboardPreTemplates.svg"} />
                                                                            <p>
                                                                                {item.env_name}</p>
                                                                        </div>

                                                                    </>
                                                                )
                                                            }


                                                            <div className={styles.dashboardDatestyle}>
                                                                <img src={process.env.PUBLIC_URL + "/NewPages/Dashboard/DateIcon.svg"} />
                                                                <p >

                                                                    {new Date(item.date).toLocaleDateString("en-GB", {
                                                                        day: "2-digit",
                                                                        month: "short",
                                                                        year: "numeric",
                                                                    })}</p>
                                                            </div>

                                                        </div>

                                                    </div>

                                                </div>

                                                <div className={styles.restoreanddelete}>

                                                    <button onClick={() => undelete(item.uuid)} className={styles.untrash}>Restore</button>
                                                    <hr style={{ borderColor: "var(--border)", marginTop: "24px", borderWidth: "1px" }} />
                                                    <div className={styles.trashremovebtn}>

                                                        <button onClick={() => { setSelectedEnv(item); setShowDeleteModal(true) }} className={styles.removefromtrash}>
                                                            Remove

                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )) : <div className={styles.Nocontent}> <p>No Projects in trash</p></div>}
                                </div>
                            </>
                        )
                    }
                    {
                        activeTrashTab === "template" && (
                            <>
                                <div className={styles.Nocontent}> <p>No Templates in trash</p></div>
                            </>
                        )
                    }

                </div>
            </div>
            <Modal show={showDeleteModal}>
                <div ref={RemovefromTrashref} className={templatestyle.warningcontainer}>

                    <div className={templatestyle.TemplateHeaderContainer}>
                        <p >Delete Project</p>
                        <button onClick={() => setShowDeleteModal(false)}>

                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </button>

                    </div>
                    <div className={templatestyle.warningContent}>
                        <p>If you delete this project, it will be moved to the Trash and can be restored anytime.</p>
                    </div>
                    <div className={templatestyle.warningbuttonsection}>
                        <button className={templatestyle.cancelBtn} onClick={() => setShowDeleteModal(false)}>Cancle</button>
                        <button className={templatestyle.DeleteWarningbtn} onClick={() => handleDelete(selectedEnv.uuid)}>Remove</button>
                    </div>



                </div>
            </Modal>
        </div>
    )
}

export default TrashedProjects